/**
 * Input
 *
 */
import React from 'react'
import { Input } from 'antd'
import { connect } from 'react-redux'

const ThemedInput = (props) => (
  <Input
    {...props}
  />
)

const connectedInput = connect(
  state => ({
    theme: state.theme.values
  })
)(ThemedInput)

export default connectedInput
